export default __webpack_public_path__ + "static/media/twitter_white1.3c5b2b26.svg";